import { createContext } from 'react';
import en_US_language_translations from '@translations/language.translation-en-US.puff.json';

export const PageContext = createContext('');
export const LanguageContext = createContext(en_US_language_translations);
